import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from 'App/routes';
import { getToken } from 'Arch/services/LocalStorageService';
import validateToken from 'Arch/services/ValidateToken';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const token = getToken();
  const allowedRoutes = [
    'Login',
    'RecoverPassword',
    'RecoverSuccess',
    'NewPassword',
  ];

  if (!validateToken(token) && allowedRoutes.indexOf(to.name) === -1) {
    return next('/login');
  }

  if (validateToken(token) && to.name === 'Login') {
    return next('/');
  }

  return next();
});

export default router;
